// Get base URL from environment variable or use default
const baseURL = process.env.REACT_APP_ADMIN_API_URL || process.env.REACT_APP_API_URL ;

// Ensure trailing slash is present
const formattedBaseURL = baseURL.endsWith('/') ? baseURL : baseURL + '/';

export const base_url = formattedBaseURL;
